module.exports = __webpack_public_path__ + "static/media/prochnost.6a5c17dc.png";